import React, { useState } from 'react';
import { useDispatch } from 'react-redux';
import { registerSuccess, registerFailure } from '../../redux/authSlice';
import { Button, TextField, Container, Typography, Paper, Box } from '@mui/material';

const SignUp = () => {
  const dispatch = useDispatch();
  const [userData, setUserData] = useState({
    username: '',
    password: '',
    email: '',
  });

  const handleInputChange = (e) => {
    setUserData({
      ...userData,
      [e.target.name]: e.target.value,
    });
  };

  const handleSignUp = () => {
     // Assuming you dispatch one of the login actions based on success or failure
    // You might want to replace the below conditions based on your actual authentication logic
    // if (/* authentication is successful */) {
      dispatch(registerSuccess({ /* user data */ }));
      // You can also redirect the user to the dashboard after successful login
    // } else {
    //   dispatch(registerFailure('Registration failed'));  // Pass an error message as needed
    // }
  };

  return (
    <Container component="main" maxWidth="xs">
      <Paper elevation={3} sx={{ padding: 3, display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
        <Typography component="h1" variant="h5">
          Sign Up
        </Typography>
        <Box component="form" noValidate sx={{ mt: 1 }}>
          <TextField
            margin="normal"
            required
            fullWidth
            label="Username"
            name="username"
            value={userData.username}
            onChange={handleInputChange}
          />
          <TextField
            margin="normal"
            required
            fullWidth
            label="Password"
            name="password"
            type="password"
            value={userData.password}
            onChange={handleInputChange}
          />
          <TextField
            margin="normal"
            required
            fullWidth
            label="Email"
            name="email"
            type="email"
            value={userData.email}
            onChange={handleInputChange}
          />
          <Button type="button" fullWidth variant="contained" onClick={handleSignUp} sx={{ mt: 3 }}>
            Sign Up
          </Button>
        </Box>
      </Paper>
    </Container>
  );
};

export default SignUp;
